import { render, staticRenderFns } from "./insurers-edit.vue?vue&type=template&id=38059ec7&scoped=true"
import script from "./insurers-edit.vue?vue&type=script&lang=js"
export * from "./insurers-edit.vue?vue&type=script&lang=js"
import style0 from "./insurers-edit.vue?vue&type=style&index=0&id=38059ec7&prod&lang=css"
import style1 from "./insurers-edit.vue?vue&type=style&index=1&id=38059ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38059ec7",
  null
  
)

export default component.exports